import { render, staticRenderFns } from "./Selectbox.vue?vue&type=template&id=129d4b60&scoped=true&"
import script from "./Selectbox.vue?vue&type=script&lang=js&"
export * from "./Selectbox.vue?vue&type=script&lang=js&"
import style0 from "./Selectbox.vue?vue&type=style&index=0&id=129d4b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129d4b60",
  null
  
)

export default component.exports